import { useAmplitudeTrackingService } from '~/composables/useAmplitudeTrackingService'
import { useBrazeTrackingService } from '~/composables/useBrazeTrackingService'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const amplitudeAPIKey = config.public.amplitudeAPIKey

  const brazeApiKey = config.public.brazeApiKey
  const brazeSdkEndpoint = config.public.brazeSdkEndpoint

  const { cookiesEnabledIds } = useCookieControl()

  const amplitudeTrackingService = useAmplitudeTrackingService()
  const brazeTrackingService = useBrazeTrackingService()

  amplitudeTrackingService.setApiKey(amplitudeAPIKey)

  if (cookiesEnabledIds.value) {
    amplitudeTrackingService.init()
  }

  brazeTrackingService.setApiKey(brazeApiKey)
  brazeTrackingService.setSdkEndpoint(brazeSdkEndpoint)

  if (import.meta.client) {
    brazeTrackingService.init()
  }

  watch(
    () => cookiesEnabledIds.value,
    (current) => {
      if (current?.includes('amplitude')) {
        // TODO Should not happen if we are in dev mode
        amplitudeTrackingService.init()
      } else {
        amplitudeTrackingService.optOut()
      }
    },
    { deep: true }
  )
})
